import React from "react";

/*
 * Brand line-art graphics for the "Moving abroad" section.
 * Replaces the old 3D emoji PNGs (/icons3d/*.png) — same three concepts,
 * drawn in the Select Proposal palette (maroon #8B1E1E + gold #D4A574).
 * Rendered inside a soft rounded badge and always horizontally centred.
 */

const MAROON = "#8B1E1E";
const GOLD = "#D4A574";

const svgProps = (size) => ({
  width: size,
  height: size,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
});

/* Plane lifting off along a dotted flight path */
export const PlaneGraphic = ({ size = 44 }) => (
  <svg {...svgProps(size)}>
    <path
      d="M6 41c6.5-3.4 12.2-8 17-13.8"
      stroke={GOLD}
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="1 5"
    />
    <path
      d="M40.9 7.1c1.7 1.7 1.4 4.9-1.4 7.7l-4.2 4.2 1.6 12.3a1 1 0 0 1-.3.8l-2.3 2.3a1 1 0 0 1-1.6-.3l-4.9-10.2-5.2 5.2.5 4.6a1 1 0 0 1-.3.8l-1.5 1.5a1 1 0 0 1-1.6-.2l-2.6-4.4-4.4-2.6a1 1 0 0 1-.2-1.6l1.5-1.5a1 1 0 0 1 .8-.3l4.6.5 5.2-5.2-10.2-4.9a1 1 0 0 1-.3-1.6l2.3-2.3a1 1 0 0 1 .8-.3l12.3 1.6 4.2-4.2c2.8-2.8 6-3.1 7.7-1.4Z"
      stroke={MAROON}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

/* Graduation cap for students & professionals */
export const GraduationGraphic = ({ size = 44 }) => (
  <svg {...svgProps(size)}>
    <path
      d="M24 9 5 17.5 24 26l19-8.5L24 9Z"
      stroke={MAROON}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M13 21.5V31c0 3.3 4.9 6 11 6s11-2.7 11-6v-9.5"
      stroke={MAROON}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M41 18.5V29" stroke={GOLD} strokeWidth="2" strokeLinecap="round" />
    <circle cx="41" cy="31.5" r="2.2" fill={GOLD} />
  </svg>
);

/* Globe with a location pin — destination city matching */
export const DestinationGraphic = ({ size = 44 }) => (
  <svg {...svgProps(size)}>
    <circle cx="22" cy="24" r="15" stroke={MAROON} strokeWidth="2" />
    <path
      d="M7 24h30M22 9c4 4.4 6 9.4 6 15s-2 10.6-6 15c-4-4.4-6-9.4-6-15s2-10.6 6-15Z"
      stroke={MAROON}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M34 12c3.3 0 6 2.7 6 6 0 4.2-6 10-6 10s-6-5.8-6-10c0-3.3 2.7-6 6-6Z"
      fill="#fff"
      stroke={GOLD}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="34" cy="18" r="2.2" fill={GOLD} />
  </svg>
);

/* Two interlocking rings — settling down together */
export const RingsGraphic = ({ size = 44 }) => (
  <svg {...svgProps(size)}>
    <circle cx="19" cy="29" r="10" stroke={MAROON} strokeWidth="2" />
    <circle cx="31" cy="29" r="10" stroke={GOLD} strokeWidth="2" />
    <path
      d="m27 12 4-5 4 5-4 4.5-4-4.5Z"
      stroke={MAROON}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

/* Soft rounded badge wrapper — keeps every graphic optically centred */
export const IconBadge = ({ children, size = 64 }) => (
  <span
    className="inline-flex items-center justify-center rounded-2xl"
    style={{
      width: size,
      height: size,
      background: "linear-gradient(135deg, #FBF1F1 0%, #F6EEE4 100%)",
      border: "1px solid #F0E0DE",
    }}
  >
    {children}
  </span>
);

export const MOVING_ABROAD_GRAPHICS = {
  graduation: GraduationGraphic,
  destination: DestinationGraphic,
  rings: RingsGraphic,
};
